const SEX = ["MALE", "FEMALE"];
const AGES = {
    0: {SEX: SEX[0], AGE: 19}, // Ошибочный номер в ИИН'е
    1: {SEX: SEX[0], AGE: 18}, // 19 век
    3: {SEX: SEX[0], AGE: 19}, // 20 век
    5: {SEX: SEX[0], AGE: 20}, // 21 век

    2: {SEX: SEX[1], AGE: 18}, // 19 век
    4: {SEX: SEX[1], AGE: 19}, // 20 век
    6: {SEX: SEX[1], AGE: 20} // 21 век
};

/**
 * @typedef {Object} nameInfo
 * @property {string} firstName Имя
 * @property {string} lastName Фамилия
 * @property {string} secondName Отчество
 */
/**
 * @description Парсинг имени формата |Фамилия Имя Отчество|
 * @param {string} fullName
 * @returns {nameInfo}
 */
function parseName(fullName) {
    if (fullName === "") {
        return {};
    }
    let parse = fullName
        .trim()
        .replace(/\s+/g, " ")
        .split(" ");
    return {
        firstName: parse[1],
        lastName: parse[0],
        secondName: typeof parse[2] !== "undefined" ? parse[2] : ""
    };
}

/**
 * @typedef {Object} parseDateFromIin
 * @property {integer} year Год
 * @property {integer} month Месяц
 * @property {integer} day День
 */

/**
 * @typedef {Object} date
 * @property {parseDateFromIin} parse Дата распаршенная по значениям
 * @property {string} formatDate Дата отформатированная по шаблону
 */
/**
 * @description Возвращает дату рождения из ИИНа
 * @param {string}  iin
 * @returns {date}
 */
function parseDateFromIin(iin) {
    let tmpDate = iin.substring(0, 6);
    let date = {
        parse: {
            year: _getAge(iin) + tmpDate.substring(0, 2),
            month: tmpDate.substring(2, 4),
            day: tmpDate.substring(4, 6)
        }
    };
    date.formatDate = `${date.parse.day}.${date.parse.month}.${date.parse.year}`;

    return date;
}

/**
 * @param iin
 * @returns {number}
 * @private
 */
function _getAge(iin) {
    let number = iin.substring(6, 7);
    return AGES[number].AGE;
}

/**
 * @param iin
 * @returns {string}
 * @private
 */
function _getSex(iin) {
    let number = iin.substring(6, 7);
    return AGES[number].SEX;
}

/**
 * @description Валидирует иин
 * @param {string}  iin
 * @param {string}  date
 * @param {string}  sex пол
 * @returns {bool}
 */
function validateIin(iin, date, sex) {
    if (iin.length !== 12) {
        return false;
    }
    if (SEX.indexOf(sex) === -1) {
        return false;
    }

    if (_getSex(iin) !== sex) {
        return false;
    }

    if (parseDateFromIin(iin).formatDate !== date) {
        return false;
    }

    return checkControlNumb(iin);
}

/**
 * @description Проверка ИИНа на контрольный разряд
 * @param {string}  iin
 * @returns {bool}
 */
function checkControlNumb(iin) {
    const FIRST_FACET = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11];
    const SECOND_FACET = [3, 4, 5, 6, 7, 8, 9, 10, 11, 1, 2];
    let tmp = [];
    let controlNumb = 0;
    for (let i = 0; i < 12; i++) {
        tmp[i] = parseInt(iin.substring(i, i + 1));
        if (i < 11) controlNumb += tmp[i] * FIRST_FACET[i];
    }
    controlNumb = controlNumb % 11;
    if (controlNumb === 10) {
        controlNumb = 0;
        for (let i = 0; i < 11; i++) controlNumb += tmp[i] * SECOND_FACET[i];
        controlNumb = controlNumb % 11;
    }

    return controlNumb === tmp[11];
}

function declension(genitive, number) {
    number = number % 100;

    return (number <= 14 && number >= 11)
        ? genitive[2]
        : (number %= 10) < 5
            ? number > 2
                ? genitive[1]
                : number === 1
                    ? genitive[0]
                    : number === 0
                        ? genitive[2]
                        : genitive[1]//number === 2
            : genitive[2]
        ;
};

function setCookie(name, value, props) {
    props = props || {}
    var exp = props.expires
    if (typeof exp == "number" && exp) {
        var d = new Date()
        d.setTime(d.getTime() + exp * 1000)
        exp = props.expires = d
    }
    if (exp && exp.toUTCString) {
        props.expires = exp.toUTCString()
    }
    value = encodeURIComponent(value)
    var updatedCookie = name + "=" + value
    for (var propName in props) {
        updatedCookie += "; " + propName
        var propValue = props[propName]
        if (propValue !== true) {
            updatedCookie += "=" + propValue
        }
    }
    document.cookie = updatedCookie
}

function getCookie(name) {
    var matches = document.cookie.match(new RegExp(
        "(?:^|; )" + name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') + "=([^;]*)"
    ))
    return matches ? decodeURIComponent(matches[1]) : undefined
}

function parseDateFromJAVA(dateObject, item) {
    let day =  dateObject[item + '.dayOfMonth'] <= 9 ? '0' + dateObject[item + '.dayOfMonth']: dateObject[item + '.dayOfMonth'];
    let month = dateObject[item + '.monthValue'] <= 9 ? '0' + dateObject[item + '.monthValue']: dateObject[item + '.monthValue'];
    let year = dateObject[item + '.year'];
    return '' + day +'.'+ month +'.'+ year;
}

export default {
    parseName,
    parseDateFromIin,
    checkControlNumb,
    validateIin,
    _getAge,
    _getSex,
    declension,
    getCookie,
    setCookie,
    parseDateFromJAVA
};
